import styled from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";

export const Wrapper = styled.div`
    > * {
        display: flex;
        align-items: stretch;
        min-height: 100%;
    }
    @media screen and (min-width: ${breakpoints.xl}) {
        background: linear-gradient(
            90deg,
            var(--color-primary-white) 0%,
            var(--color-primary-white) 49%,
            var(--color-grey-1) 49%
        );
    }
`;

export const Grid = styled.section`
    width: 100%;
    min-height: 100%;
    padding: 0;
    @media screen and (min-width: ${breakpoints.xl}) {
        display: grid;
        grid-template-columns: auto 464px;
        grid-template-rows: auto 100px;
    }
`;

export const LocationPicker = styled.div`
    padding: 0 var(--spacing-2);
    border-block-start: 1px solid var(--color-grey-4);
    background: var(--color-primary-white);
    @media screen and (min-width: ${breakpoints.md}) {
        padding: 0 var(--spacing-3);
    }
    @media screen and (min-width: ${breakpoints.xl}) {
        display: flex;
        flex-direction: column;
        order: 1;
        border-block: 0;
        padding-inline: var(--spacing-3) var(--spacing-6);
    }
`;

export const DeliveryPicker = styled.div`
    position: relative;
    padding: 0 var(--spacing-2);
    border-block-start: 1px solid var(--color-grey-4);
    background: var(--color-primary-white);
    @media screen and (min-width: ${breakpoints.md}) {
        padding: 0 var(--spacing-3);
    }
    @media screen and (min-width: ${breakpoints.xl}) {
        order: 1;
        border-block: 0;
        padding-inline: var(--spacing-3) var(--spacing-6);
    }
`;

export const Destinations = styled.div`
    padding: var(--spacing-2);
    background: var(--color-grey-1);
    @media screen and (min-width: ${breakpoints.md}) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: var(--spacing-3);
        padding: var(--spacing-3);
        > div {
            display: flex;
            flex-direction: column;
            align-items: stretch;
        }
    }
    @media screen and (min-width: ${breakpoints.xl}) {
        display: block;
        order: 2;
        padding: var(--spacing-5);
        border-inline-start: 1px solid var(--color-grey-4);
        > div {
            display: block;
        }
    }
`;

export const Return = styled.div`
    padding: var(--spacing-2);
    border-block-end: 1px solid var(--color-grey-4);
    background: var(--color-primary-white);
    @media screen and (min-width: ${breakpoints.md}) {
        padding: var(--spacing-3);
        border: none;
    }
    @media screen and (min-width: ${breakpoints.xl}) {
        order: 3;
        padding: var(--spacing-6) var(--spacing-5) var(--spacing-3);
    }
`;

export const Continue = styled.div`
    padding: var(--spacing-2);
    background: var(--color-grey-1);
    @media screen and (min-width: ${breakpoints.md}) {
        padding: var(--spacing-3);
    }
    @media screen and (min-width: ${breakpoints.xl}) {
        order: 4;
        padding: var(--spacing-3) var(--spacing-5);
        border-inline-start: 1px solid var(--color-grey-4);
    }
`;

/* Cards */

export const Card = styled.div`
    flex-grow: 1;
    margin-block: var(--spacing-2) var(--spacing-4);
    padding: var(--spacing-2);
    background: var(--color-primary-white);
    border: 1px solid var(--color-grey-6);
    border-radius: 4px;
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-1);
`;

export const DisabledCard = styled.div`
    flex-grow: 1;
    margin-block: var(--spacing-2) var(--spacing-4);
    padding: var(--spacing-2);
    background: var(--color-grey-4);
    border: 1px solid var(--color-grey-6);
    border-radius: 4px;
`;

export const Error = styled.div`
    margin-block: var(--spacing-5);
    padding: var(--spacing-2);
    color: var(--color-highlight-red);
    border: 2px solid var(--color-highlight-red);
    border-radius: 4px;
    @media screen and (min-width: ${breakpoints.md}) {
        margin-block: var(--spacing-7);
    }
`;

export const ErrorHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-1);
    margin-bottom: var(--spacing-2);
    font-family: var(--font-semi-bold);
    font-size: 1.3rem;
    text-transform: uppercase;
`;
